import { useContext, useMemo, useRef } from 'react'
import CopyCardButton from '../dashboard/CopyCardButton'
import { SavedIcon } from '../../StateManagment/SavedIcon'

/**
 * Numbered section header for deep-analysis cards (redesign): a kicker row
 * with an auto-numbered chip, a section title and an optional description.
 * The number comes from a CSS counter on `.deep-analysis-sections`, so
 * sections that don't render (or have no kicker) never leave a gap.
 *
 * De kop draagt ook 'Kopiëren als afbeelding' voor de hele sectie (kop,
 * grafiek en de cijfertabel eronder), net als een dashboardkaart. In de kop en
 * niet per sectie: alle secties hebben deze kop, dus elke sectie krijgt hem,
 * ook een die later bijkomt (Groentjessoep, 2026-10-28).
 *
 * @param {object} props
 * @param {string} props.kicker - Short uppercase label, e.g. 'Resultaat'
 * @param {string} props.title - Section title, e.g. 'Groei tussen de meetmomenten'
 * @param {string} [props.description] - One or two explanatory sentences under the title
 */
const DeepAnalysisSectionHeader = ({ kicker, title, description }) => {
    /** @type {React.RefObject<HTMLDivElement>} */
    const headRef = useRef(null)
    // De knop meldt via de snackbar van de app (SavedProvider, rond de hele
    // app). Een kop die daarbuiten rendert — de tests van de secties — krijgt
    // geen knop: die zou zijn uitkomst nergens kwijt kunnen.
    const canReport = !!useContext(SavedIcon)

    // De sectie waar deze kop in staat; pas bij het klikken opgezocht, dan
    // staat alles in de DOM.
    const sectionRef = useMemo(() => ({
        get current() {
            return headRef.current?.closest('.deep-analysis-section') || null
        },
    }), [])

    return (
        <div className='deep-analysis-section-head' ref={headRef}>
            <div className='deep-analysis-section-kicker'>
                <span className='deep-analysis-section-kicker-n' aria-hidden='true' />
                {kicker}
                {canReport && (
                    <span className='deep-analysis-section-copy'>
                        <CopyCardButton targetRef={sectionRef} />
                    </span>
                )}
            </div>
            <h3 className='deep-analysis-section-title'>{title}</h3>
            {description && <p className='deep-analysis-section-desc'>{description}</p>}
        </div>
    )
}

export default DeepAnalysisSectionHeader
